<button id="show-founder-btn" hidden (click)="showSuccess = true" class="btn btn-primary">{{'show_founder_message' | translate}}</button>
<ds-modal-one
  [modalOneInput]="modalOneConfig">
  <div class="modal-content-wrapper" modal-body>
    <div class="title-description">
        <h6 class="body-title">{{loginUserName}}</h6><br>
         <p class="body-description" [innerHTML]="modalDescription"></p><br>
        <h6 class="body-title">Sunil Nigam</h6>
        <p class="body-description">CEO - Founder</p>
    </div>
  </div>
  <div modal-footer>
    <ds-button
        [buttonInput]="buttonConfig"
        (btnClick)="onClick()">
    </ds-button>
  </div>
</ds-modal-one>